import { Controller } from "@hotwired/stimulus"

// Инициализирует Swagger UI на странице документации API.
//
// Раньше инициализация висела на window "load", и при переходе через Turbo
// это событие не наступало — страница открывалась пустой, пока её не обновишь.
// Stimulus вызывает connect() и при первой загрузке, и при каждой Turbo-навигации.
//
// Бандл Swagger UI весит больше мегабайта, поэтому он не входит в общий
// application.js, а подгружается здесь — только на этой странице и только один раз
// за сессию: промис кэшируется на уровне модуля.
let bundlePromise = null

function loadBundle(src) {
  if (window.SwaggerUIBundle) return Promise.resolve()

  if (!bundlePromise) {
    bundlePromise = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = src
      script.onload = resolve
      script.onerror = () => {
        // Сбрасываем кэш, чтобы следующий заход мог попробовать снова.
        bundlePromise = null
        reject(new Error(`Не удалось загрузить Swagger UI: ${src}`))
      }
      document.head.appendChild(script)
    })
  }

  return bundlePromise
}

export default class extends Controller {
  static values = {
    specUrl: String,
    bundleUrl: String
  }

  connect() {
    loadBundle(this.bundleUrlValue)
      .then(() => this.render())
      .catch((error) => this.showError(error))
  }

  disconnect() {
    // Turbo кэширует страницу вместе с отрисованным деревом Swagger UI.
    // Без очистки при возврате назад поверх старого дерева отрисовалось бы второе.
    this.element.innerHTML = ""
  }

  render() {
    // За время загрузки бандла пользователь мог уйти на другую страницу.
    if (!this.element.isConnected) return

    window.SwaggerUIBundle({
      url: this.specUrlValue,
      dom_id: `#${this.element.id}`,
      deepLinking: true,
      supportedSubmitMethods: ["get", "post"]
    })
  }

  showError(error) {
    console.error(error)
    this.element.innerHTML =
      '<p class="text-sm text-red-700">Не удалось загрузить документацию. Обновите страницу.</p>'
  }
}
